if (!customElements.get('taffstyle-whatsapp-invite')) {
  customElements.define('taffstyle-whatsapp-invite', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.dialog = this.querySelector('dialog');
      this.launcher = this.querySelector('[data-wa-open]');
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.launcher.addEventListener('click', () => {
        this.update();
        if (this.hidden) return;
        this.dialog.showModal();
        this.launcher.setAttribute('aria-expanded','true');
      }, options);
      this.querySelector('[data-wa-dismiss]').addEventListener('click', () => this.close(), options);
      this.querySelector('[data-wa-follow]').addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('close', () => this.launcher.setAttribute('aria-expanded','false'), options);
      document.addEventListener('taffstyle:privacy-state', () => this.update(), options);
      this.cart = document.getElementById('cart');
      if (this.cart) {
        this.cartObserver = new MutationObserver(() => this.update());
        this.cartObserver.observe(this.cart,{attributes:true,attributeFilter:['class','aria-hidden']});
      }
      this.update();
    }
    update() {
      const privacy = document.querySelector('taffstyle-privacy');
      const available = privacy?.dataset.ready === 'true' && privacy.dataset.decided === 'true' && privacy.dataset.open !== 'true';
      const cartOpen = this.cart?.classList.contains('toggle') || this.cart?.getAttribute('aria-hidden') === 'false';
      this.hidden = !available || cartOpen;
      if (this.hidden && this.dialog.open) this.dialog.close();
    }
    close() { this.dialog.close(); if (!this.hidden) this.launcher.focus({preventScroll:true}); }
    disconnectedCallback() { this.events?.abort(); this.cartObserver?.disconnect(); }
  });
}
